import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CreateRoundingConditionSchema } from './createRoundingConditionSchema';
import { PriceRoundingRuleConfig } from '@retail/rounding/types';
import { Image, RadioInput } from '@retail/components';
import { Stack, Tooltip, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { ConditionsNew } from '@retail/calculus/types';

interface Props {
  priceRoundingRuleConfigs: PriceRoundingRuleConfig[];
  existingPriceRoundingCondition?: ConditionsNew;
}

export const SelectPriceRoundingCondition: React.FC<Props> = ({
  priceRoundingRuleConfigs,
  existingPriceRoundingCondition,
}) => {
  const { control } = useFormContext<CreateRoundingConditionSchema>();
  const t = useAppTFunction();

  return (
    <RadioInput
      name="priceRoundingId"
      label={t('calculus.rounding.chooseRuleSet')}
      options={priceRoundingRuleConfigs.map((rule) => {
        const isSelected = rule.id === existingPriceRoundingCondition?.roundingCondition?.ruleSetId;
        return {
          label: (
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography>{rule.name}</Typography>
              {rule.centralOwner && (
                <Tooltip
                  title={t('rounding.ruleOwner.central', {
                    owner: rule.centralOwner.name,
                  })}
                >
                  <Image
                    src={rule.centralOwner.imgUrl}
                    alt={rule.centralOwner.name}
                    width={32}
                    height={32}
                  />
                </Tooltip>
              )}
              {isSelected && <Typography>{`(${t('calculus.current')})`}</Typography>}
            </Stack>
          ),
          value: rule.id,
        };
      })}
      control={control}
      required
    />
  );
};
